module.exports = __webpack_public_path__ + "static/media/douja.5ec6f273.png";